/* ============================================================
   GOBLIN GEAR — Shopping experience upgrade (gg-conversion.js, Oct 2026)
   1. Bundle offers above Add to cart ([Product name] / Get the Set / Two of each / The Full Kit)
      with photo dropdowns (picture, name, price) for the Set partner and the apparel piece
   2. Live Add-to-cart label with the bundle price + Buy now (add the bundle, straight to checkout)
   3. Sticky add-to-cart bar, desktop + mobile; turns into "Buy now" once the bundle is in the cart
   4. Added-to-cart pop-up with a one-tap "complete the pair" and a Buy now button
   5. Delivery estimate timeline + ship-cutoff countdown
   6. Store-credit "earn" line + tooltip
   7. Light vs dark A/B test reporting (cart attributes + customer event)
   Config: #ggCartConfig (snippets/cart-drawer.liquid). Cart I/O: gg-cart.js (window.GGCart).
   Masked. But known.
   ============================================================ */
(function () {
  'use strict';
  if (window.__ggConv) return; window.__ggConv = 1;

  var GG = window.GG = window.GG || {};
  var CFG = {};
  try { CFG = JSON.parse((document.getElementById('ggCartConfig') || {}).textContent || '{}'); } catch (e) {}
  var MODE = CFG.mode === 'credit' ? 'credit' : 'discount';
  var DISC = (CFG.tiers || [{ n: 2, pct: 5 }, { n: 4, pct: 10 }]).slice().sort(function (a, b) { return a.n - b.n; });
  var CRED = (CFG.credit || [{ n: 2, pct: 5 }, { n: 4, pct: 10 }]).slice().sort(function (a, b) { return a.n - b.n; });
  var TOAST_MS = 9000;
  /* Buy now settings come from the product section (data-buy-now on the form); CFG is the fallback. */
  var BN_SRC = document.querySelector('[data-gpd-form]') || { getAttribute: function () { return null; } };
  var BN_RAW = BN_SRC.getAttribute('data-buy-now') || CFG.buyNow;
  var BN_MODE = BN_RAW === 'off' || BN_RAW === false ? 'off' : (BN_RAW === 'after_add' ? 'after_add' : 'always');
  var BN_LABEL = BN_SRC.getAttribute('data-buy-now-label') || CFG.buyNowLabel || 'Buy now';
  var BN = null, justAdded = null, stkBtn = null, STK = null;

  function money(c) { return '$' + ((c || 0) / 100).toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function mobile() { return window.matchMedia('(max-width: 760px)').matches; }
  function tierFor(list, n) { var cur = null; list.forEach(function (t) { if (n >= t.n) cur = t; }); return cur; }
  function nextTier(list, n) { for (var i = 0; i < list.length; i++) { if (n < list[i].n) return list[i]; } return null; }
  function jsonFetch(url, body) {
    return fetch(url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) } : { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); });
  }
  function getCart() { return jsonFetch('/cart.js').then(function (r) { return r.j; }); }
  function syncCart() {
    if (window.GGCart && GGCart.sync) return GGCart.sync();
    return getCart();
  }

  /* ---------------------------------------------------------
     1 + 2 · Bundle offers above Add to cart
     --------------------------------------------------------- */
  var OFF = document.querySelector('[data-gg-offers]');
  var FORM = document.querySelector('[data-gpd-form]');
  var ATC = document.getElementById('ppAtc');
  var state = { items: null, total: 0, title: '', earn: 0 };
  var cards = [];

  /* One line per variant: the same wrap can appear twice (e.g. X-Lite Loadout = two of each). */
  function addLine(list, id, q) {
    if (!id || !q) return;
    var hit = list.filter(function (l) { return l.id === id; })[0];
    if (hit) hit.quantity += q; else list.push({ id: id, quantity: q });
  }
  function selPick(sel) { var opt = sel && sel.options[sel.selectedIndex]; return opt ? { id: parseInt(opt.value, 10), price: parseInt(opt.getAttribute('data-price'), 10) || 0 } : null; }
  function offerData(card) {
    var o = OFF.dataset, qT = parseInt(card.getAttribute('data-q-this'), 10) || 0, qP = parseInt(card.getAttribute('data-q-partner'), 10) || 0;
    var base = parseInt(o.price, 10) || 0, items = [], sub = base * qT, units = qT;
    addLine(items, parseInt(o.vid, 10), qT);
    if (qP) {
      var pp = selPick(OFF.querySelector('[data-o-partner]'));
      if (pp) { addLine(items, pp.id, qP); sub += pp.price * qP; units += qP; }
    }
    var extra = []; try { extra = JSON.parse(card.getAttribute('data-extra') || '[]'); } catch (e) {}
    extra.forEach(function (x) { addLine(items, x.id, x.q || 1); sub += (x.price || 0) * (x.q || 1); units += (x.q || 1); });
    if (card.hasAttribute('data-has-apparel')) {
      var ap = selPick(card.querySelector('[data-o-apparel]'));
      if (ap) { addLine(items, ap.id, 1); sub += ap.price; units += 1; }
    }
    var pct, total = sub, earn = 0;
    if (MODE === 'credit') {
      pct = (tierFor(CRED, units) || { pct: 0 }).pct; earn = Math.floor(sub * pct / 100);
    } else {
      pct = (tierFor(DISC, units) || { pct: 0 }).pct; total = Math.round(sub * (100 - pct) / 100);
    }
    var title = (card.querySelector('.go-title') || {}).textContent || '';
    return { items: items, units: units, sub: sub, total: total, pct: pct, earn: earn, title: title.trim() };
  }
  function paintCard(card, d) {
    var t = card.querySelector('[data-o-total]'), w = card.querySelector('[data-o-was]'), r = card.querySelector('[data-o-reward]');
    if (t) t.textContent = money(d.total);
    if (w) { w.textContent = money(d.sub); w.hidden = !(d.total < d.sub); }
    if (r) { r.textContent = MODE === 'credit' ? (d.earn ? 'Earn ' + money(d.earn) + ' credit' : '') : (d.pct ? 'Save ' + d.pct + '%' : ''); r.hidden = !r.textContent; }
  }
  function setAtcLabel() {
    if (!ATC || ATC.disabled) return;
    var span = ATC.querySelector('span'); if (!span) return;
    span.innerHTML = 'Add to cart<span class="gg-atc-price">' + money(state.total) + '</span>';
  }
  function paintEarn() {
    var txt = document.querySelector('[data-earn-txt]'); if (!txt) return;
    var first = CRED[0] || { n: 2, pct: 5 };
    txt.innerHTML = state.earn > 0 ? 'Earn <b>' + money(state.earn) + '</b> in store credit on this bundle'
      : 'Bundle ' + first.n + '+ items and earn <b>' + first.pct + '% back</b> in store credit';
  }
  function choose(val, fromSticky) {
    cards.forEach(function (c) {
      var on = c.getAttribute('data-offer') === String(val);
      c.classList.toggle('is-on', on);
      var r = c.querySelector('input[type=radio]'); if (r) r.checked = on;
      if (on) { var d = offerData(c); state = { items: d.items, total: d.total, title: d.title, earn: d.earn, units: d.units, val: String(val) }; }
    });
    setAtcLabel(); paintEarn(); paintSticky(fromSticky); paintBuy();
  }

  /* Photo dropdown over a native <select class="go-pick">: the button shows the picked item's photo,
     name and price; the list shows every option the same way. The native select stays in the page
     (hidden) and keeps the value, so prices and Add to cart read it exactly as before.
     Picking from a card's dropdown also selects that card. */
  var openDD = null;
  function closeDD() {
    if (!openDD) return;
    openDD.list.hidden = true; openDD.btn.setAttribute('aria-expanded', 'false'); openDD.root.classList.remove('is-open'); openDD = null;
  }
  function optHTML(o) {
    var img = o.getAttribute('data-img'), t = o.getAttribute('data-title') || o.textContent, pr = parseInt(o.getAttribute('data-price'), 10) || 0;
    return '<span class="gp-th">' + (img ? '<img src="' + esc(img) + '" alt="" width="40" height="40" loading="lazy">' : '') + '</span>' +
      '<span class="gp-nm">' + esc(t) + '</span><span class="gp-pr">' + money(pr) + '</span>';
  }
  var ddN = 0;
  function photoPick(sel) {
    var root = document.createElement('span'), lid = 'ggdd' + (++ddN);
    root.className = 'gp-dd';
    root.innerHTML = '<button type="button" class="gp-btn" aria-haspopup="listbox" aria-expanded="false" aria-controls="' + lid + '"></button>' +
      '<span class="gp-list" role="listbox" id="' + lid + '" tabindex="-1" hidden></span>';
    sel.parentNode.insertBefore(root, sel.nextSibling);
    sel.classList.add('gp-native'); sel.tabIndex = -1; sel.setAttribute('aria-hidden', 'true');
    var btn = root.firstChild, list = root.lastChild, act = 0;
    btn.setAttribute('aria-label', (sel.getAttribute('aria-label') || 'Choose') + ': ' + ((sel.options[sel.selectedIndex] || {}).text || ''));
    list.setAttribute('aria-label', sel.getAttribute('aria-label') || 'Choose');
    function paint() {
      var o = sel.options[sel.selectedIndex];
      btn.innerHTML = (o ? optHTML(o) : '') + '<svg class="gp-chev" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';
      if (o) btn.setAttribute('aria-label', (sel.getAttribute('aria-label') || 'Choose') + ': ' + (o.getAttribute('data-title') || o.text));
      list.innerHTML = [].map.call(sel.options, function (op, i) {
        return '<span class="gp-opt" role="option" id="' + lid + '-' + i + '" data-i="' + i + '" aria-selected="' + (i === sel.selectedIndex) + '">' + optHTML(op) +
          '<svg class="gp-tick" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg></span>';
      }).join('');
    }
    function focusOpt(i) {
      var opts = list.querySelectorAll('.gp-opt'); if (!opts.length) return;
      act = Math.max(0, Math.min(opts.length - 1, i));
      [].forEach.call(opts, function (o, j) { o.classList.toggle('is-act', j === act); });
      list.setAttribute('aria-activedescendant', opts[act].id);
      try { list.focus({ preventScroll: true }); } catch (e) { list.focus(); }
      if (opts[act].scrollIntoView) opts[act].scrollIntoView({ block: 'nearest' });
    }
    function open() {
      closeDD(); paint(); list.hidden = false; root.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true');
      openDD = { root: root, btn: btn, list: list }; focusOpt(sel.selectedIndex);
      /* Opening a card's dropdown means the shopper wants that bundle: select the card too. */
      var f = sel.getAttribute('data-pick-for'); if (f && state.val !== f) choose(f);
    }
    function pick(i) {
      closeDD();
      if (i !== sel.selectedIndex) { sel.selectedIndex = i; sel.dispatchEvent(new Event('change', { bubbles: true })); }
      else { var f = sel.getAttribute('data-pick-for'); if (f) choose(f); }
      paint(); try { btn.focus({ preventScroll: true }); } catch (e) {}
    }
    /* preventDefault stops the surrounding <label> from also toggling its radio; we select the card ourselves. */
    root.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var op = e.target.closest('.gp-opt');
      if (op) { pick(parseInt(op.getAttribute('data-i'), 10)); return; }
      if (e.target.closest('.gp-btn')) { if (openDD && openDD.root === root) closeDD(); else open(); }
    });
    list.addEventListener('mousemove', function (e) { var op = e.target.closest('.gp-opt'); if (op) { var i = parseInt(op.getAttribute('data-i'), 10); if (i !== act) focusOpt(i); } });
    btn.addEventListener('keydown', function (e) { if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); open(); } });
    list.addEventListener('keydown', function (e) {
      var k = e.key;
      if (k === 'ArrowDown') { e.preventDefault(); focusOpt(act + 1); }
      else if (k === 'ArrowUp') { e.preventDefault(); focusOpt(act - 1); }
      else if (k === 'Home') { e.preventDefault(); focusOpt(0); }
      else if (k === 'End') { e.preventDefault(); focusOpt(sel.options.length - 1); }
      else if (k === 'Enter' || k === ' ') { e.preventDefault(); pick(act); }
      else if (k === 'Escape') { e.preventDefault(); closeDD(); btn.focus(); }
      else if (k === 'Tab') { closeDD(); }
    });
    sel.addEventListener('change', paint);
    paint();
  }
  document.addEventListener('click', function (e) { if (openDD && !openDD.root.contains(e.target)) closeDD(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openDD) { var b = openDD.btn; closeDD(); b.focus(); } });

  function partnerImg(sel) {
    var opt = sel.options[sel.selectedIndex], img = opt && opt.getAttribute('data-img');
    if (!img) return;
    OFF.querySelectorAll('[data-o-partner-img]').forEach(function (box) {
      var im = box.querySelector('img');
      if (im) im.src = img; else box.insertAdjacentHTML('afterbegin', '<img src="' + esc(img) + '" alt="" width="80" height="80">');
    });
  }
  function apparelImg(sel) {
    var opt = sel.options[sel.selectedIndex], box = OFF.querySelector('[data-o-apparel-img]');
    if (box && opt) box.innerHTML = opt.getAttribute('data-img') ? '<img src="' + esc(opt.getAttribute('data-img')) + '" alt="" width="80" height="80">' : '';
  }

  if (OFF) {
    cards = [].slice.call(OFF.querySelectorAll('.gg-offer'));
    if (FORM) FORM.classList.add('has-offers');
    cards.forEach(function (c) {
      c.querySelector('input[type=radio]').addEventListener('change', function () { choose(c.getAttribute('data-offer')); });
    });
    [].forEach.call(OFF.querySelectorAll('select.go-pick'), function (sel) {
      if (sel.hasAttribute('data-o-apparel')) apparelImg(sel);
      sel.addEventListener('change', function () {
        if (sel.hasAttribute('data-o-partner')) partnerImg(sel); else apparelImg(sel);
        cards.forEach(function (c) { paintCard(c, offerData(c)); });
        choose(sel.getAttribute('data-pick-for') || state.val || '1');
        buildStickyOptions();
      });
      photoPick(sel);
    });
    var checked = OFF.querySelector('input[type=radio]:checked') || OFF.querySelector('input[type=radio]');
    cards.forEach(function (c) { paintCard(c, offerData(c)); });
    choose(checked ? checked.value : '1');
  }
  /* The product page's own add() asks for this. null = no offers, use the quantity box. */
  GG.offerItems = function () { return OFF && state.items && state.items.length ? state.items : null; };

  /* ---------------------------------------------------------
     3 · Sticky add-to-cart bar
     --------------------------------------------------------- */
  STK = document.querySelector('[data-gg-sticky]');
  var stkPick = STK && STK.querySelector('[data-gs-pick]');
  stkBtn = STK && STK.querySelector('[data-gs-add]');
  function buildStickyOptions() {
    if (!stkPick || !cards.length) return;
    stkPick.innerHTML = cards.map(function (c) {
      var d = offerData(c);
      return '<option value="' + c.getAttribute('data-offer') + '">' + esc(d.title) + ' — ' + money(d.total) + (MODE === 'credit' ? (d.earn ? ' · earn ' + money(d.earn) : '') : (d.pct ? ' (save ' + d.pct + '%)' : '')) + '</option>';
    }).join('');
    STK.querySelector('[data-gs-pickwrap]').hidden = false;
    stkPick.value = state.val || '1';
  }
  function paintSticky(fromSticky) {
    if (!STK) return;
    var p = STK.querySelector('[data-gs-price]'); if (p && state.total) p.textContent = money(state.total);
    if (stkPick && !fromSticky && state.val) stkPick.value = state.val;
  }
  if (STK) {
    document.body.appendChild(STK); /* escape any transformed ancestor so position:fixed anchors to the viewport */
    buildStickyOptions(); paintSticky(); paintBuy();
    if (stkPick) stkPick.addEventListener('change', function () { choose(stkPick.value, true); });
    if (stkBtn) stkBtn.addEventListener('click', function () {
      /* Once this exact bundle is in the cart the bar reads "Buy now" and goes straight to checkout. */
      if (stkBtn.classList.contains('is-buy')) { stkBtn.classList.add('busy'); goCheckout(); return; }
      if (!FORM) return;
      stkBtn.classList.add('busy'); stkBtn.disabled = true;
      setTimeout(function () { stkBtn.disabled = false; stkBtn.classList.remove('busy'); }, 4000);
      if (FORM.requestSubmit) FORM.requestSubmit(); else FORM.dispatchEvent(new Event('submit', { cancelable: true }));
    });
    var anchor = ATC || FORM;
    var setOn = function (on) {
      STK.classList.toggle('is-on', on); STK.setAttribute('aria-hidden', on ? 'false' : 'true');
      document.body.classList.toggle('gg-has-sticky', on);
      document.documentElement.style.setProperty('--gg-sticky-h', on ? STK.offsetHeight + 'px' : '0px');
    };
    if (anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (ents) {
        ents.forEach(function (e) { setOn(!e.isIntersecting && e.boundingClientRect.top < 0); });
      }, { threshold: 0 }).observe(anchor);
    } else if (anchor) {
      window.addEventListener('scroll', function () { setOn(anchor.getBoundingClientRect().bottom < 0); }, { passive: true });
    }
  }
  function stickyDone() { if (stkBtn) { stkBtn.disabled = false; stkBtn.classList.remove('busy'); } }

  /* ---------------------------------------------------------
     3b · Buy now — add the picked bundle and go straight to checkout.
     Signed-in customers and Shop Pay users land on checkout with their details filled in.
     Product section settings → Buy buttons → Buy now: always / after add only / off.
     --------------------------------------------------------- */
  function selKey(items) { return (items || []).map(function (i) { return i.id + 'x' + i.quantity; }).sort().join(','); }
  function curItems() {
    var o = GG.offerItems && GG.offerItems(); if (o) return o;
    if (!FORM) return [];
    var q = FORM.querySelector('[data-qty]');
    return [{ id: parseInt(FORM.getAttribute('data-vid'), 10), quantity: Math.max(1, parseInt(q && q.value, 10) || 1) }];
  }
  function goCheckout() { window.location.href = '/checkout'; }
  function paintBuy() {
    var hot = !!justAdded && justAdded === selKey(curItems());
    if (BN) {
      BN.classList.toggle('is-hot', hot);
      if (BN_MODE === 'after_add') BN.hidden = !hot;
    }
    if (stkBtn && STK) {
      stkBtn.classList.toggle('is-buy', hot);
      var l = STK.querySelector('[data-gs-label]');
      if (l && !stkBtn.disabled) l.innerHTML = hot ? esc(BN_LABEL) : 'Add to cart' + (state.total ? '<span class="gs-bp"> · ' + money(state.total) + '</span>' : '');
    }
  }
  function bnBusy(on) { if (!BN) return; BN.disabled = on; BN.classList.toggle('busy', on); }
  function bnError(j) {
    var m = BN && BN.parentNode.querySelector('.gg-buynow-err');
    if (!BN) return;
    if (!m) { m = document.createElement('p'); m.className = 'gg-buynow-err'; m.setAttribute('role', 'alert'); BN.parentNode.insertBefore(m, BN.nextSibling); }
    m.textContent = (j && (j.description || j.message)) || 'That didn’t go through. Please try again.';
    m.hidden = false;
  }
  function buyNow() {
    var items = curItems(), key = selKey(items);
    if (!items.length) return;
    bnBusy(true);
    var addThenGo = function () {
      return jsonFetch('/cart/add.js', { items: items }).then(function (r) {
        if (r.ok) { justAdded = key; goCheckout(); return; }
        bnBusy(false); bnError(r.j);
      });
    };
    /* Same bundle just added (and still in the cart)? Don't add it twice — go. */
    var run = justAdded === key
      ? getCart().then(function (c) { if (c && c.item_count > 0) goCheckout(); else return addThenGo(); })
      : addThenGo();
    Promise.resolve(run).catch(function () { bnBusy(false); bnError(null); });
    setTimeout(function () { bnBusy(false); }, 8000);
  }
  if (ATC && FORM && BN_MODE !== 'off' && !ATC.disabled) {
    BN = document.createElement('button');
    BN.type = 'button';
    BN.className = 'btn btn-ghost gg-buynow';
    BN.setAttribute('data-gg-buynow', '');
    BN.innerHTML = '<span>' + esc(BN_LABEL) + '</span> <span class="arrow">&rarr;</span>';
    if (BN_MODE === 'after_add') BN.hidden = true;
    FORM.parentNode.insertBefore(BN, FORM.nextSibling);
    BN.addEventListener('click', buyNow);
    paintBuy();
  }
  var atcHome = ATC && ATC.querySelector('span') ? ATC.querySelector('span').innerHTML : '';
  function flashAdded() {
    var span = ATC && ATC.querySelector('span'); if (!span) return;
    span.innerHTML = 'Added to cart ✓'; ATC.classList.add('is-added');
    setTimeout(function () { ATC.classList.remove('is-added'); if (OFF && state.total) setAtcLabel(); else span.innerHTML = atcHome; }, 1800);
  }

  /* ---------------------------------------------------------
     4 · After add: drawer, pop-up, or both
     --------------------------------------------------------- */
  var TOAST = document.getElementById('ggToast');
  var toastTimer = null, toastLeft = TOAST_MS, toastStart = 0;

  function slotOf(pid) { var s = null; (CFG.wave1 || []).forEach(function (p) { if (p.pid === pid) s = p.slot; }); return s; }
  function tierKey(url) { var h = String(url || '').split('?')[0].split('/').pop(); return h.replace(/-(elbow|wrist)-wraps$/, ''); }
  function suggestFor(item, cart) {
    var slot = slotOf(item.product_id); if (!slot) return null;
    var other = slot === 'wrist' ? 'elbow' : 'wrist', inCart = {}, haveOther = false;
    (cart.items || []).forEach(function (i) { inCart[i.product_id] = 1; if (slotOf(i.product_id) === other) haveOther = true; });
    /* No partner in the cart yet → complete the pair. Partner already there → suggest the next piece of the bundle. */
    var mine = tierKey(item.url), list = (CFG.wave1 || []).filter(function (p) { return (haveOther || p.slot === other) && p.available !== false && !inCart[p.pid]; });
    list.sort(function (a, b) { return (tierKey(a.url) === mine ? 0 : 1) - (tierKey(b.url) === mine ? 0 : 1); });
    if (!list[0]) return null;
    return { p: list[0], heading: haveOther ? 'Add to your bundle' : 'Complete the pair' };
  }
  function incentive(cart) {
    var n = cart.item_count || 0, nx;
    if (MODE === 'credit') {
      var cur = tierFor(CRED, n), earn = Math.floor((cart.total_price || 0) * (cur ? cur.pct : 0) / 100);
      nx = nextTier(CRED, n);
      return (earn ? 'You’re earning <b>' + money(earn) + '</b> in store credit. ' : '') + (nx ? 'Add ' + (nx.n - n) + ' more item' + (nx.n - n === 1 ? '' : 's') + ' to earn <b>' + nx.pct + '% back</b>.' : '<b>' + cur.pct + '% back</b> unlocked on this order.');
    }
    var c = tierFor(DISC, n); nx = nextTier(DISC, n);
    if (!nx) return '<b>' + c.pct + '% off</b> unlocked on your whole bundle.';
    return (c ? '<b>' + c.pct + '% off</b> unlocked. ' : '') + 'Add ' + (nx.n - n) + ' more item' + (nx.n - n === 1 ? '' : 's') + ' to unlock <b>' + nx.pct + '% off</b>.';
  }
  function upsellLine(cart, s) {
    var n = (cart.item_count || 0) + 1;
    if (MODE === 'credit') { var t = tierFor(CRED, n); return 'Earn ' + money(Math.floor(((cart.total_price || 0) + s.price) * (t ? t.pct : 0) / 100)) + ' credit total'; }
    var d = tierFor(DISC, n), prev = tierFor(DISC, n - 1);
    return d && d !== prev ? 'Unlocks ' + d.pct + '% off your bundle' : 'Add to your bundle';
  }
  function hideToast() {
    if (!TOAST) return;
    clearTimeout(toastTimer); TOAST.classList.remove('is-on');
    setTimeout(function () { if (!TOAST.classList.contains('is-on')) TOAST.hidden = true; }, 350);
  }
  function armTimer(ms) { clearTimeout(toastTimer); toastStart = Date.now(); toastLeft = ms; toastTimer = setTimeout(hideToast, ms); }
  function showToast(resp, cart) {
    if (!TOAST || !cart) return;
    var added = (resp && resp.items) ? resp.items : (resp ? [resp] : []);
    if (!added.length) return;
    var first = added[0], qty = added.reduce(function (n, i) { return n + (i.quantity || 1); }, 0);
    var lineTotal = added.reduce(function (n, i) { return n + (i.final_line_price || i.line_price || 0); }, 0);
    var hit = suggestFor(first, cart), sug = hit && hit.p;
    var pay = document.getElementById('ggPayTpl');
    TOAST.style.setProperty('--gg-toast-ms', TOAST_MS + 'ms');
    TOAST.innerHTML =
      '<div class="gtst-h"><h4 id="ggToastH"><span class="ok"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M20 6L9 17l-5-5"/></svg></span>Added to cart</h4><button type="button" class="gtst-x" data-t-x aria-label="Close">&times;</button></div>' +
      '<div class="gtst-item"><span class="gtst-th">' + (first.image ? '<img src="' + esc(first.image) + '" alt="">' : '') + '</span>' +
        '<div><div class="gtst-nm">' + esc(first.product_title) + '</div><div class="gtst-meta">' + (added.length > 1 ? '+ ' + (added.length - 1) + ' more · ' : '') + qty + ' item' + (qty === 1 ? '' : 's') + '</div></div>' +
        '<span class="gtst-pr">' + money(lineTotal) + '</span></div>' +
      (sug ? '<div class="gtst-up"><span class="gtst-up-k">' + esc(hit.heading) + '</span><div class="gtst-up-row"><span class="gtst-th">' + (sug.img ? '<img src="' + esc(sug.img) + '" alt="">' : '') + '</span>' +
        '<span class="gtst-up-nm">' + esc(sug.title) + '<em>' + money(sug.price) + ' · ' + esc(upsellLine(cart, sug)) + '</em></span>' +
        '<button type="button" class="btn btn-primary gtst-up-add" data-t-up="' + sug.id + '">+ Add</button></div></div>' : '') +
      '<p class="gtst-msg" data-t-msg>' + incentive(cart) + '</p>' +
      '<div class="gtst-cta"><button type="button" class="btn btn-ghost" data-t-view>View cart (' + cart.item_count + ')</button><a class="btn btn-primary" href="/checkout" data-t-buy>' + esc(BN_LABEL) + ' <span class="arrow">&rarr;</span></a></div>' +
      (pay ? '<div class="gtst-pay">' + pay.innerHTML + '</div>' : '');
    TOAST.hidden = false;
    /* rAF doesn't fire in a background tab; the timeout makes sure the pop-up still shows. */
    requestAnimationFrame(function () { TOAST.classList.add('is-on'); });
    setTimeout(function () { if (!TOAST.hidden) TOAST.classList.add('is-on'); }, 60);
    /* restart the drain bar */
    TOAST.classList.remove('is-held', 'is-run'); void TOAST.offsetWidth; TOAST.classList.add('is-run');
    armTimer(TOAST_MS);
    TOAST.querySelector('[data-t-x]').addEventListener('click', hideToast);
    TOAST.querySelector('[data-t-view]').addEventListener('click', function () { hideToast(); if (window.GGCart) GGCart.refresh(); });
    var up = TOAST.querySelector('[data-t-up]');
    if (up) up.addEventListener('click', function () {
      up.disabled = true; up.textContent = '...';
      jsonFetch('/cart/add.js', { items: [{ id: parseInt(up.getAttribute('data-t-up'), 10), quantity: 1 }] }).then(function (r) {
        if (!r.ok) { up.disabled = false; up.textContent = '+ Add'; return; }
        up.textContent = 'Added ✓'; up.classList.add('is-done');
        return syncCart().then(function (c) {
          var m = TOAST.querySelector('[data-t-msg]'); if (m && c) m.innerHTML = incentive(c);
          var v = TOAST.querySelector('[data-t-view]'); if (v && c) v.textContent = 'View cart (' + c.item_count + ')';
          armTimer(TOAST_MS);
        });
      });
    });
  }
  if (TOAST) {
    var hold = function () { clearTimeout(toastTimer); toastLeft = Math.max(1500, toastLeft - (Date.now() - toastStart)); TOAST.classList.add('is-held'); };
    var resume = function () { TOAST.classList.remove('is-held'); armTimer(toastLeft); };
    TOAST.addEventListener('mouseenter', hold); TOAST.addEventListener('mouseleave', resume);
    TOAST.addEventListener('focusin', hold); TOAST.addEventListener('focusout', resume);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && TOAST.classList.contains('is-on')) hideToast(); });
  }

  /* The product page calls this after a successful /cart/add.js. */
  window.GGAfterAdd = function (items, resp) {
    stickyDone();
    justAdded = selKey(items); paintBuy(); flashAdded();
    var err = document.querySelector('.gg-buynow-err'); if (err) err.hidden = true;
    var mode = CFG.afterAdd || 'both';
    var useDrawer = mode === 'drawer' || (mode === 'both' && !mobile());
    var useToast = mode !== 'drawer' && !!TOAST;
    var p = useDrawer && window.GGCart ? GGCart.refresh() : syncCart();
    if (useToast) Promise.resolve(p).then(function (cart) { showToast(resp, cart); });
    document.dispatchEvent(new CustomEvent('gg:added', { detail: { items: items, response: resp } }));
    return p;
  };

  /* ---------------------------------------------------------
     5 · Delivery estimate
     --------------------------------------------------------- */
  [].forEach.call(document.querySelectorAll('[data-gg-eta]'), function (el) {
    var d = el.dataset, tz = d.tz || 'America/New_York';
    var cutoff = parseInt(d.cutoff, 10), proc = parseInt(d.proc, 10) || 0, tmin = parseInt(d.tmin, 10) || 2, tmax = parseInt(d.tmax, 10) || 5;
    if (isNaN(cutoff)) cutoff = 14;
    function nowParts() {
      try {
        var f = new Intl.DateTimeFormat('en-US', { timeZone: tz, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' });
        var o = {}; f.formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; }); return o;
      } catch (e) { var n = new Date(); return { year: n.getFullYear(), month: n.getMonth() + 1, day: n.getDate(), hour: n.getHours(), minute: n.getMinutes() }; }
    }
    function biz(dt) { var w = dt.getUTCDay(); return w !== 0 && w !== 6; }
    function addBiz(dt, n) { var x = new Date(dt.getTime()); while (n > 0) { x.setUTCDate(x.getUTCDate() + 1); if (biz(x)) n--; } return x; }
    function nextBiz(dt) { var x = new Date(dt.getTime()); do { x.setUTCDate(x.getUTCDate() + 1); } while (!biz(x)); return x; }
    function fmt(dt) { return dt.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' }); }
    function fmtShort(dt) { return dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' }); }
    function paint() {
      var p = nowParts(), today = new Date(Date.UTC(+p.year, +p.month - 1, +p.day, 12)), hr = +p.hour, mn = +p.minute;
      var beforeCut = biz(today) && hr < cutoff, start = beforeCut ? today : nextBiz(today);
      var ship = addBiz(start, proc), a = addBiz(ship, tmin), b = addBiz(ship, tmax);
      var shipTxt = ship.getTime() === today.getTime() ? 'today' : fmt(ship);
      var head = el.querySelector('[data-eta-head]');
      if (beforeCut) {
        var left = (cutoff * 60) - (hr * 60 + mn), h = Math.floor(left / 60), m = left % 60;
        head.innerHTML = 'Order within <b>' + (h ? h + 'h ' : '') + m + 'm</b> and it ships <b>' + shipTxt + '</b>';
      } else {
        head.innerHTML = 'Order now and it ships <b>' + shipTxt + '</b>';
      }
      el.querySelector('[data-eta-d1]').textContent = fmt(ship);
      el.querySelector('[data-eta-d2]').textContent = fmtShort(a) + ' – ' + fmtShort(b);
      el.hidden = false;
    }
    paint(); setInterval(paint, 30000);
  });

  /* ---------------------------------------------------------
     6 · Earn tooltip
     --------------------------------------------------------- */
  [].forEach.call(document.querySelectorAll('[data-earn-toggle]'), function (b) {
    var tip = document.getElementById(b.getAttribute('aria-controls'));
    if (!tip) return;
    b.addEventListener('click', function (e) { e.stopPropagation(); var open = tip.hidden; tip.hidden = !open; b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    document.addEventListener('click', function (e) { if (!tip.hidden && !tip.contains(e.target)) { tip.hidden = true; b.setAttribute('aria-expanded', 'false'); } });
  });

  /* ---------------------------------------------------------
     7 · Light vs dark A/B test — tag the cart so every order records its arm
     --------------------------------------------------------- */
  if (window.GG_AB_THEME) {
    var arm = window.GG_AB_THEME, root = document.documentElement, sentKey = 'gg-ab-sent', t = null;
    var report = function () {
      var seen = root.getAttribute('data-theme') || arm, payload = arm + '|' + seen, sent = null;
      try { sent = sessionStorage.getItem(sentKey); } catch (e) {}
      if (sent === payload) return;
      jsonFetch('/cart/update.js', { attributes: { _gg_theme_ab: arm, _gg_theme_seen: seen } }).then(function (r) {
        if (r.ok) { try { sessionStorage.setItem(sentKey, payload); } catch (e) {} }
      }).catch(function () {});
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('gg_theme_ab', { arm: arm, seen: seen }); } catch (e) {}
      try { (window.dataLayer = window.dataLayer || []).push({ event: 'gg_theme_ab', gg_theme_arm: arm, gg_theme_seen: seen }); } catch (e) {}
    };
    report();
    try { new MutationObserver(function () { clearTimeout(t); t = setTimeout(report, 800); }).observe(root, { attributes: true, attributeFilter: ['data-theme'] }); } catch (e) {}
  }
})();
